import React from "react";
import { Search } from "lucide-react";

// ── VN token resolutions used for canvas-style inline styles ────────────────
// innerBg dark  #101828 → rgba(16,24,40,0.50)   innerBg light #d5dde8 → rgba(213,221,232,0.40)
// inputBorder dark #304658 → rgba(48,70,88,0.70) inputBorder light #788698 → rgba(120,134,152,0.35)
// (Tailwind token classes are used where applicable; resolved hex only for inline bg/border)

/* ── Reusable pill section for the view modal ── */
const ViewPillSection = ({
  label,
  count,
  searchVal,
  onSearch,
  placeholder,
  children,
  t,
  dark,
}) => (
  <div className="mb-2">
    <label className="mb-1 block text-[0.8125rem] font-normal tracking-wide text-mutedText">
      {label}
      {count > 0 && (
        // velBlue token — replaces hardcoded text-sky-400
        <span className="ml-1.5 text-[10px] text-velBlue">({count})</span>
      )}
    </label>

    {/* Search input — VN input pattern */}
    <div className="relative mb-1">
      {React.createElement(Search, {
        size: 11,
        style: {
          position: "absolute",
          left: 8,
          top: "50%",
          transform: "translateY(-50%)",
          opacity: 0.4,
        },
      })}
      <input
        type="text"
        className={`w-full pl-7 pr-3 py-1 rounded-lg text-[11px] outline-none transition
          ${t.input.bg} border ${t.input.border} ${t.input.text} ${t.input.placeholder}
          ${t.input.focusBorder}`}
        placeholder={placeholder}
        value={searchVal}
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>

    {/* Pill container — innerBg family with inputBorder */}
    <div
      className="flex flex-wrap gap-1 max-h-[90px] overflow-y-auto p-1.5 rounded-lg"
      style={{
        // innerBg dark #101828 / light #d5dde8 — resolved with opacity
        background: dark ? "rgba(16,24,40,0.50)" : "rgba(213,221,232,0.40)",
        // inputBorder dark #304658 / light #788698 — resolved with opacity
        border: `1px solid ${dark ? "rgba(48,70,88,0.70)" : "rgba(120,134,152,0.35)"}`,
        scrollbarWidth: "thin",
      }}
    >
      {children}
    </div>
  </div>
);

const ViewTypePill = ({ active, icon, iconColor, label, onClick, dark }) => (
  <button
    type="button"
    className="flex items-center gap-1 px-1.5 py-0.5 rounded-lg text-[10px] transition cursor-pointer"
    style={{
      // Active: velBlue/15 bg + velBlue/30 border + velBlue text (two-signal rule)
      background: active ? "rgba(14,165,233,0.15)" : "transparent",
      border: active
        ? "1px solid rgba(14,165,233,0.30)"
        : `1px solid ${
            dark
              ? // inputBorder dark at 55% opacity — defines structure without shouting
                "rgba(48,70,88,0.55)"
              : // inputBorder light at 30% opacity
                "rgba(120,134,152,0.30)"
          }`,
      // Active text: velBlue resolved. Inactive: mutedText resolved
      color: active
        ? "rgb(14,165,233)"
        : dark
          ? "rgba(148,163,184,0.70)"
          : "rgba(100,116,139,0.70)",
    }}
    onClick={onClick}
  >
    {icon &&
      React.createElement(icon, {
        size: 10,
        style: { color: iconColor || "inherit", flexShrink: 0 },
      })}
    {label}
  </button>
);

export { ViewPillSection, ViewTypePill };
